//---------------------------------------------
// Regionais Module 
//---------------------------------------------
// Módulo para gerenciar as regionais

import axios from '../../services/api';
import Cookies from 'js-cookie';
var JWT = () => {
    return (Cookies.get("accessToken") ? Cookies.get("accessToken") : "JWT VAZIO")
}

// STATES
const state = () => ({
    regionais: [],
    regionalUnica: [],
})

// MUTATIONS
const mutations = {
    //-- MUTATION PARA ALTERAR ESTADO DAS REGIONAIS
    setRegionais(state, payload) {
        state.regionais = payload
    },

    setRegionalUnica(state, payload){
        state.regionalUnica = payload;
    }
}

// ACTIONS
const actions = {
    //-- ACTION REQUISICAO DO LISTFORMS
    async setRegionais({ commit },) {
        await axios
            .get(`/regionais`,
                {
                    headers: {
                        'Authorization': `Bearer ${JWT()}`
                    }
                })
            .then(response => {
                commit('setRegionais', response.data)
            })
            .catch((error) => console.log(error.message))
    },

    async setRegionalUnica({ commit }, payload) {
        await axios
            .get(`/regionais/${payload.idRegional}`,
                {
                    headers: {
                        'Authorization': `Bearer ${JWT()}`
                    }
                })
            .then(response => {
                commit('setRegionalUnica', response.data)
            })
            .catch((error) => console.log(error.message))
    },
}

// GETTERS
const getters = {
    getRegionais(state) {
        try {
            return state.regionais.data
        } catch (e) {
            return []
        }
    },

    getRegionalUnica(state) {
        try {
            return state.regionalUnica
        } catch (e) {
            return []
        }
    },

}

export default {
    state,
    mutations,
    actions,
    getters
}
